import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import './assets/scss/styles.scss'
import { translate, linkTo } from '../../assets/js/functions';
import { Helmet } from 'react-helmet';
import Footer from '../../layouts/Footer';

export default function Home({currentPage}){

    useEffect(() => {
        currentPage && currentPage(window.location.pathname);
    }, [])

    return (
        <div id="home">
            <div className="bg-image-home"></div>
            <Helmet>
                <title>{translate("Centros de detención Pamplona")}</title>
            </Helmet>
            <Row className='home-section top'>
                <Col sm={12}>
                    <span className='title'>
                        <h1>
                            {translate("La ciudad de los cautivos")}
                        </h1>
                        <h3>
                            {translate("Centros de detención en Pamplona, 1936-1945")}
                        </h3>
                    </span>
                </Col>
            </Row>
            <Row className='home-section middle'>
                <Col sm={6} className='cautividad'>
                    <Link to={linkTo("/captivity")} className="btn-home">
                        <span>{ translate("La cautividad") }</span>
                        <span className='subtitle'>({ translate("Exposición") })</span>
                    </Link>
                </Col>
                <Col sm={6} className='ciudad'>
                    <Link to={linkTo("/map")} className="btn-home">
                        <span>{ translate("La ciudad") }</span>
                        <span className='subtitle'>({ translate("Mapa") })</span>
                    </Link>
                </Col>
            </Row>
            {/* <Row className='home-section bottom'>
                <Col sm={12} className='recorridos'>
                    <Link to="/map" className="btn-home btn-bottom"><span>{ translate("Los recorridos") }</span></Link>
                </Col>
            </Row> */}
            <Footer/>
        </div>
    )
}
